export const roles = (roles,t) =>{
const namedRoles = roles.map((role)=>t(`auth.roles.${role}`))
return `${namedRoles}`
}